// Definição para o modal de busca de Tipos de Produto
// Utilizada no cadastro de Produtos para seleção de Tipo de Produto
// Factory function - recebe idEmpresa como parâmetro opcional

import { PROD_NATUREZA } from '@/constants/PROD_NATUREZA'

export const criarConfigBuscaTipoProduto = (idOrganizacao = null) => {
  const filtrosFixos = {
    lstNaturezaItem: PROD_NATUREZA.ProdutoFisico
  }
  if (idOrganizacao) {
    filtrosFixos.idOrganizacao = idOrganizacao
  }
  return {
    label: 'Tipo de Produto',
    placeholder: 'Buscar tipo de produto...',
    titulo: 'Pesquisar Tipo de Produto',
    endpointApi: 'TiposProduto',
    idField: 'idTipoProduto',
    displayField: 'descricaoBreve',
    descField: 'descricao',
    tabela: 'TipoProduto',
    colunasGrid: [
      { header: 'Código', dataField: 'idTipoProduto', width: '80px' },
      { header: 'Descrição', dataField: 'descricaoBreve' },
      { header: 'Descrição Completa', dataField: 'descricao' },
      { header: 'Natureza', dataField: 'lstNaturezaItem', width: '120px' }
    ],
    camposFiltro: [
      { model: 'busca', label: 'Descrição', tipo: 'text' }
    ],
    filtrosFixos
  }
}
